import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiGet, apiPost, TENANT_TOKEN_KEY } from '../api/client';

export function TenantPasswordChangePage() {
  const nav = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(TENANT_TOKEN_KEY)) {
      nav('/login', { replace: true });
    }
  }, [nav]);

  useEffect(() => {
    const token = localStorage.getItem(TENANT_TOKEN_KEY);
    if (!token) return;
    void (async () => {
      try {
        const me = await apiGet<{ user: { mustChangePassword?: boolean } }>('/api/auth/me', token, { showErrorGrowl: false });
        if (!me.user.mustChangePassword) {
          nav('/app', { replace: true });
        }
      } catch {
        /* token inválido: el otro effect o el formulario manejan */
      }
    })();
  }, [nav]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    const cur = currentPassword.normalize('NFKC').trim();
    const np = newPassword.normalize('NFKC').trim();
    const cp = confirmPassword.normalize('NFKC').trim();
    if (np.length < 8) {
      setErr('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (np !== cp) {
      setErr('La confirmación no coincide con la nueva contraseña.');
      return;
    }
    const token = localStorage.getItem(TENANT_TOKEN_KEY);
    if (!token) {
      nav('/login', { replace: true });
      return;
    }
    setLoading(true);
    try {
      const data = await apiPost<{ token: string }>(
        '/api/auth/change-password',
        { currentPassword: cur, newPassword: np },
        token,
        { successMessage: 'Contraseña actualizada' }
      );
      localStorage.setItem(TENANT_TOKEN_KEY, data.token);
      nav('/app', { replace: true });
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <h1 style={{ margin: '0 0 8px', fontSize: 22 }}>Nueva contraseña</h1>
        <p style={{ margin: '0 0 20px', color: '#64748b', fontSize: 14 }}>
          Tu cuenta usa una contraseña temporal. Ingresá la actual y elegí una nueva para acceder a la consola.
        </p>
        <form onSubmit={onSubmit}>
          <label style={label}>
            Contraseña actual
            <input
              style={input}
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <label style={label}>
            Nueva contraseña (mín. 8 caracteres)
            <input
              style={input}
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={8}
            />
          </label>
          <label style={label}>
            Confirmar nueva contraseña
            <input
              style={input}
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={8}
            />
          </label>
          {err ? <p style={{ color: '#b91c1c', fontSize: 14 }}>{err}</p> : null}
          <button type="submit" disabled={loading} style={btnPrimary}>
            {loading ? 'Guardando…' : 'Guardar y continuar'}
          </button>
        </form>
        <p style={{ margin: '20px 0 0', fontSize: 13, color: '#94a3b8' }}>
          <Link to="/login" style={{ color: '#7c3aed' }} onClick={() => localStorage.removeItem(TENANT_TOKEN_KEY)}>
            Cerrar sesión y volver al inicio
          </Link>
        </p>
      </div>
    </div>
  );
}

const wrap: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
};

const card: React.CSSProperties = {
  width: '100%',
  maxWidth: 420,
  background: '#fff',
  borderRadius: 12,
  padding: 28,
  border: '1px solid #e2e8f0',
  boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
};

const label: React.CSSProperties = {
  display: 'block',
  fontSize: 13,
  color: '#475569',
  marginBottom: 14,
};

const input: React.CSSProperties = {
  display: 'block',
  width: '100%',
  marginTop: 6,
  padding: '10px 12px',
  borderRadius: 8,
  border: '1px solid #cbd5e1',
  fontSize: 15,
};

const btnPrimary: React.CSSProperties = {
  width: '100%',
  marginTop: 8,
  padding: '12px',
  borderRadius: 8,
  border: 'none',
  background: '#7c3aed',
  color: '#fff',
  fontWeight: 600,
  fontSize: 15,
  cursor: 'pointer',
};
